import { CTA, CTAProps } from '@/components/CTA';
import { Typography } from '@eventbrite/marmalade';
import classNames from 'classnames';
import React from 'react';

import styles from './CTABlock.module.scss';

interface CTABlockProps {
  ctas: CTAProps[];
  caption?: string;
  className?: string;
  showInverse?: boolean;
}

export const CTABlock: React.FC<CTABlockProps> = ({
  ctas,
  caption,
  className = '',
  showInverse = false,
}) => {
  const styleClassName = classNames(
    styles['cta-block'],
    className,
    showInverse && styles.cta_block_inverse,
  );

  return (
    <div className={styleClassName}>
      <div className={classNames(styles['ctas'], 'ctablock_ctas')}>
        {ctas.slice(0, 2).map((cta, index) => (
          <CTA
            key={index}
            label={cta.label}
            link={cta.link}
            type={cta.type}
            dataHeapId={cta.dataHeapId}
            showInverse={showInverse}
          />
        ))}
      </div>
      {caption && <Typography className={styles.caption}>{caption}</Typography>}
    </div>
  );
};
